import React, { useState } from 'react';
import { Stack, Paper,Grid, TextField, Button, Typography} from '@mui/material/';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

//components imports
import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import MailRecord from '../dataObjects/MailRecord';

interface SaveMailRecordProps {
    mailRecord?: MailRecord | null;
    closeMailRecordForm: (reload: boolean) => void;
}

const SaveMailRecordForm = (props: SaveMailRecordProps): JSX.Element => {

    const [currentMailRecord, setCurrentMailRecord] = useState(props.mailRecord? props.mailRecord: null);

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();

    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    const saveMailRecord = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const recordId = currentMailRecord ? currentMailRecord.id : 0;

        formData.append("id", recordId.toLocaleString());

        fetch(`/StaffTools/SaveMailRecord`,
            {
                method: 'POST',
                body: formData,
            })
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: SaveMailRecord',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let info = {
                        type: 'success',
                        title: 'The Mail Record Saved',
                        errorMessage: 'The mail record was saved successfully!',
                        secondaryErrorMessage: ''
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                    props.closeMailRecordForm(true);
                }
            });
    }

    return (
        <>
            <form onSubmit={(event: React.FormEvent<HTMLFormElement>) => saveMailRecord(event)}>
                <Paper sx={{ p: 1 }} >
                    <Grid item xs={12} marginTop={2} >
                        <Stack marginBottom={3} >
                            {
                                props.mailRecord ?
                                <Typography variant="subtitle1"> Update the Mail Info...</Typography>
                                    :
                                <Typography variant="subtitle1"> Add A New Mail Info...</Typography>
                            }
                        </Stack>
                        <Stack spacing={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    sx={{ minWidth: 100, width: 350 }}
                                    name="date"
                                    label="Date"
                                    defaultValue={currentMailRecord ? dayjs(currentMailRecord.date) : dayjs()}
                                />
                            </LocalizationProvider>
                            <TextField
                                margin="normal"
                                name="description"
                                label="Mail Description"
                                fullWidth
                                defaultValue={currentMailRecord ? currentMailRecord.description : ''}
                            />
                            <TextField
                                margin="normal"
                                name="recipientsDescription"
                                label="Recipients Description"
                                defaultValue={currentMailRecord ? currentMailRecord.recipientsDescription : ''}
                                fullWidth
                            />
                            <Stack direction="row" spacing={4}>
                                <TextField
                                    margin="normal"
                                    name="mailsCount"
                                    label="Count of Mails Sent?"
                                    defaultValue={currentMailRecord ? currentMailRecord.mailsCount : ''}
                                />
                                { /*upload*/}
                                <Stack direction="row" spacing={1} alignItems={"center"} >
                                    <Typography variant="body2">
                                        Attach File:
                                    </Typography>
                                    <input type="file" name="file" />
                                </Stack>
                            </Stack>
                        </Stack>
                        <Stack direction="row" spacing={2} justifyContent={"flex-end"} marginTop={2} >
                            <Button variant="outlined" color="warning" onClick={()=> props.closeMailRecordForm(false)} >Cancel</Button>
                            <Button variant="outlined" color="success" type="submit">Save</Button>
                        </Stack>
                    </Grid>
                </Paper>
            </form>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    )
}

export default SaveMailRecordForm;